import React, { useEffect, useRef, useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { InputNumber } from 'primereact/inputnumber';
import { Form555 } from '../../services/Form/555-form';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Api } from '../../services/api';
import { Toast } from 'primereact/toast';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Editor } from 'primereact/editor';
import { IoArrowBackSharp } from 'react-icons/io5';
import { MultiSelect } from 'primereact/multiselect';

import { FaPrint, FaSave, FaEnvelope } from 'react-icons/fa';

import './print.css';

import printJS from 'print-js'

function QuarterlyConversation() {
  const navigate = useNavigate();

  const [isSavePopupOpen, setIsSavePopupOpen] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [customMessage, setCustomMessage] = useState('');
  const [customSubject, setCustomSubject] = useState('Quarterly Huddle Conversation');

  const [to, setTo] = useState('Y');
  const [toName, setToName] = useState('');
  const [customCC, setCustomCC] = useState('Y');
  const [humanResourcesCC, setHumanResourcesCC] = useState('Y');
  const [vpConstructionCC, setVpConstructionCC] = useState('Y');
  const [presidentCC, setPresidentCC] = useState('Y');
  const [supervisor_status, setSupervisor_status] = useState('Y');


  const [allSupervisors, setAllSupervisors] = useState([]);
  const [selectedCCList, setSelectedCCList] = useState([]);
  const [showName, setShowName] = useState('');
  const { editId } = useParams();
  // console.log("editId, ", editId);
  const [Section1Array, setSection1Array] = useState(Form555.getFormName().section_2);
  const [Section2Array, setSection2Array] = useState(Form555.getFormName().section_3);
  const [Section3Array, setSection3Array] = useState(Form555.getFormName().section_4);
  const [Section4Array, setSection4Array] = useState(Form555.getFormName().section_5);
  const [statusSaveButton, setStatusSaveButton] = useState('ACTIVE');
  const [isSupervisorButton, setIsSupervisorButton] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState('');

  // 1️⃣ put a ref on the element you want to print  
  const formRef = useRef(null)


  const formik = useFormik({
    initialValues: {
      ...Form555.getFormName(),
      customMessage: '',
      customSubject: '',
      to: '',
      customCC: '',
      humanResourcesCC: '',
      vpConstructionCC: '',
      presidentCC: '',
      cc_users: [],
      is_supervisor: false,
    },
    validate: (data) => {
    },


    onSubmit: (data) => {
      setSaveLoading(true)
      console.log(JSON.stringify(data));
      data.user_id = localStorage.getItem('user_id');
      console.log(data.user_id)
      data.role_id = localStorage.getItem('role_id');

      const token = localStorage.getItem('authToken');
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        "Content-Type": "application/json",
      };

      fetch(Api.API_BASE_URL + '555/save', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          setSaveLoading(false);
          console.log(response)
          if (response.error != '') {
            setToastMessage(response.error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
          } else {
            setToastMessage(response.result);
            toast.current.show({ severity: 'success', summary: 'Success', detail: response.result, life: 3000 });
            setSelectedCCList([]);

          }
          setTimeout(() => {
            setToastMessage('');
            setIsLoading(false);
          }, 5000);

        })
    },


  });

  function handlePrint() {
    printJS({
      printable: 'formRef',
      type: 'html',
      scanStyles: true,
      css: ['./print.css'],
      targetStyles: ['*'],
      honorMarginPadding: true,
      honorColor: true,
      header: '<h1 style="text-align: center; margin-bottom: 20px;">Quarterly Huddle Conversation</h1>',
      documentTitle: 'Quarterly Huddle',
      maxWidth: 1500,
      font: 'Arial',
      font_size: '10pt',
      style: `
        @page { size: A4 landscape; margin: 1.5cm; }
        @media print {
          body { font-family: Arial, sans-serif; line-height: 1.6; margin: 0; padding: 0; }
          table { page-break-inside: avoid !important; margin: 20px 0; width: 100%; border-collapse: collapse; }
          tr { page-break-inside: avoid !important; page-break-after: auto !important; }
          td, th { page-break-inside: avoid !important; padding: 12px; border: 1px solid #000; }
          th { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
          .p-inputtextarea, .p-inputtext { background: transparent !important; border: none !important; }
          * { box-sizing: border-box !important; }
        }
      `
    });
  }

  const openSavePopup = (e) => {
    e.preventDefault();
    setSelectedCCList([]);
    setIsSavePopupOpen(true);
  };

  const directSave = (e) => {
    e.preventDefault();
    formik.setFieldValue('customMessage', customMessage, true);
    formik.setFieldValue('customSubject', customSubject, true);
    formik.setFieldValue('to', to, true);
    formik.setFieldValue('customCC', customCC, true);
    formik.setFieldValue('humanResourcesCC', humanResourcesCC, true);
    formik.setFieldValue('vpConstructionCC', vpConstructionCC, true);
    formik.setFieldValue('presidentCC', presidentCC, true);
    formik.setFieldValue('notification_send', 'N');
    formik.handleSubmit();
  };

  const handleSaveSubmit = (e) => {
    e.preventDefault();
    var isNotificationAdmin = false;
    var user_id = localStorage.getItem('user_id');
    if (user_id == formik.values.supervisor_id) {

    } else if (user_id == formik.values.team_member_id) {

    } else { isNotificationAdmin = true; }

    formik.setFieldValue('isNotificationAdmin', isNotificationAdmin);
    formik.setFieldValue('notification_send', 'Y');
    formik.setFieldValue('to', to,);
    formik.setFieldValue('customCc', customCC,);
    formik.setFieldValue('humanResourcesCC', humanResourcesCC,);
    formik.setFieldValue('vpConstructionCC', vpConstructionCC,);
    formik.setFieldValue('presidentCC', presidentCC,);
    formik.setFieldValue('customSubject', customSubject,);
    formik.setFieldValue('customMessage', customMessage,);

    formik.setFieldValue('cc_users', selectedCCList.map(user => user.email));

    setIsSavePopupOpen(false);
    formik.handleSubmit();
  };

  //* --------------------------------------------------
  useEffect(() => {
    console.log('working')

    getProjectDetails();
    getUser();
    return () => {
      // Cleanup tasks before the component is unmounted
    };

  }, []);
  const getUser = async () => {
    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      const response = await axios.get(Api.API_BASE_URL + 'get-all-users', { headers: headers });

      setAllSupervisors(response.data.result);

      // setSupervisor_id([...response.data.supervisor_id]);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setIsLoading(false);
    }
  };

  const getProjectDetails = () => {

    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    var conversationId = 0;
    if (editId != undefined) {
      conversationId = editId;
    }

    console.log('llllllllllllllllllllllll', conversationId)

    var _body = {
      user_id: user_id,
      role_id: role_id,
      conversationId: conversationId,

    };

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + '555/get', {
      method: 'POST',
      body: JSON.stringify(_body),
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false);
        setIsSupervisor(response.isSuperVisor);

        formik.setFieldValue(`is_supervisor`, response.isSuperVisor);
        if (response.error != '') {
          formik.setFieldValue(`team_member_name`, response.team_member_name);
          formik.setFieldValue(`supervisor_name`, response.supervisor_name);
          formik.setFieldValue(`supervisor_id`, response.supervisor_id);
          formik.setFieldValue(`team_member_id`, response.team_member_id);

          formik.setFieldValue(`conversationId`, 0);
          if (user_id == response.supervisor_id) {
            // setIsSupervisor(true);
          }
        } else {
          setShowName(response.section_1.team_member_name)
          if (user_id == response.section_1.team_member_id) {
            setShowName(response.section_1.supervisor_name)
          }

          formik.setFieldValue(`conversationId`, response.section_1._id);
          formik.setFieldValue(`team_member_name`, response.section_1.team_member_name);
          formik.setFieldValue(`supervisor_name`, response.section_1.supervisor_name);
          formik.setFieldValue(`supervisor_id`, response.section_1.supervisor_id);
          formik.setFieldValue(`team_member_id`, response.section_1.team_member_id);
          formik.setFieldValue(`date`, response.section_1.date);
          formik.setFieldValue(`quater`, response.section_1.quater);
          formik.setFieldValue(`year`, response.section_1.year);
          formik.setFieldValue(`notes`, response.section_1.notes);

          formik.setFieldValue(`human_resources`, response.section_1.human_resources);
          formik.setFieldValue(`human_resources_notes`, response.section_1.human_resources_notes);
          formik.setFieldValue(`vp_construction`, response.section_1.vp_construction);
          formik.setFieldValue(`vp_construction_notes`, response.section_1.vp_construction_notes);
          formik.setFieldValue(`president`, response.section_1.president);
          formik.setFieldValue(`president_notes`, response.section_1.president_notes);
          formik.setFieldValue(`supervisor_status`, response.section_1.supervisor_status);
          formik.setFieldValue(`supervisor_notes`, response.section_1.supervisor_notes);

          setStatusSaveButton(response.section_1.active);
          if (response.section_2.length != 0) {
            // formik.setValues('section_2',response.section_2);
            formik.setFieldValue(`section_2`, response.section_2);
            setSection1Array(response.section_2);
          }
          if (response.section_3.length != 0) {
            formik.setFieldValue(`section_3`, response.section_3);
            setSection2Array(response.section_3);
          }
          if (response.section_4.length != 0) {
            formik.setFieldValue(`section_4`, response.section_4);
            setSection3Array(response.section_4);
          }
          if (response.section_5.length != 0) {
            formik.setFieldValue(`section_5`, response.section_5);
            setSection4Array(response.section_5);
          }
          if (response.section_6.length != 0) {
            formik.setFieldValue(`section_6`, response.section_6);

          }
          if (response.section_7.length != 0) {
            formik.setFieldValue(`section_7`, response.section_7);
          }
          if (response.section_8.length != 0) {
            formik.setFieldValue(`section_8`, response.section_8);
          }
          if (response.section_9.length != 0) {
            formik.setFieldValue(`section_9`, response.section_9);
          }
          if (response.section_10.length != 0) {
            formik.setFieldValue(`section_10`, response.section_10);
          }
          if (response.section_11.length != 0) {
            formik.setFieldValue(`section_11`, response.section_11);
          }
        }
      })
  };

  //* --------------------------------------------------

  //? --------------------------------------------------

  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "14px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
  };

  const cellStylec = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'center',
  };

  const cellStyleh = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'center',
    height: '40px'
  };

  const cellStylee = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    textAlign: 'end',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'

  };

  const yesCellStyle = {
    ...cellStyle,
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
  };

  //? --------------------------------------------------

  // ----------------------------------------------------------------------------
  const renderTextArea = (fieldName, placeholder, formData = '', rowCount = 2) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '14px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
    ></textarea>
  );

  const renderTextAreaFull = (fieldName, placeholder, formData = '', rowCount = 2) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      rows={rowCount}
      autoResize
      id={fieldName}
      value={formData !== '' ? formData : formik.values[fieldName]}

      onChange={(e) => {
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '14px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', padding: '4px' }}
    ></InputTextarea>
  );

  const renderInputArea = (fieldName, placeholder = '', type = 'text', formData = '', disabled = false) => (

    <input
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      step="any"
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '14px', textAlign: 'center', marginTop: '0px', }}

    />
  );

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      // value={formData != '' ? formData : formik.values[fieldName]}
      // onChange={(e) => {
      //     setExistPageWithoutSave(true);
      //     formik.setFieldValue(fieldName, e.value)}
      // }
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "14px",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  const renderSelect = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">No</option>
      <option value="Y">Yes</option>
      <option value="NA">NA</option>
    </select>
  };


  const renderSelect1 = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];
    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      // className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'white', backgroundColor: '#686D76', border: 'none' }}
    >
      <option selected disabled value=""></option>
      <option value="Q1">Quarter-1</option>
      <option value="Q2">Quarter-2</option>
      <option value="Q3">Quarter-3</option>
      <option value="Q4">Quarter-4</option>
    </select>
  };


  const renderSelect2 = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      // className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'Black', backgroundColor: 'transparent', border: 'none' }}
    >
      <option value="minus">-</option>
      <option value="plus">+</option>
      <option value="both">+/-</option>
    </select>
  };

  const renderSelectDone = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];

    if (val == undefined) {
      val = 'N'
    }
    return <select
      name={fieldName}
      id={fieldName}
      className={'select-text-color-' + val}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', height: "46px", fontSize: '14px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">Off Track</option>
      <option value="NA">On Track</option>
      <option value="Y">Done</option>
    </select>
  };


  const renderYearSelect = (fieldName, formdata = '') => {
    const currentYear = new Date().getFullYear(); // Get the current year
    var val = (formdata !== '') ? formdata : formik.values[fieldName];
    if (val === undefined) {
      val = currentYear; // Default to the current year
    }

    const years = [];
    for (let year = 2020; year <= 2030; year++) {
      years.push(year);
    }

    return (
      <select
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        onChange={(e) => {
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'Black', font: 'bold', backgroundColor: '#EEEEEE', border: 'none' }}
      >
        <option selected disabled value=''></option>
        {years.map(year => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
    );
  };

  // ----------------------------------------------------------------------------
  const toast = useRef(null);
  // ----------------------------------------------------------------------------

  const handleAddInputForSection1Array = () => {
    setSection1Array([...Section1Array, { name: '', }]);

    formik.values.section_2.push({
      title: '',
      description: '',
    });

  };

  const handleDeleteInputForSection1Array = (index) => {
    setSection1Array([...Section1Array, { name: '', }]);
    const newArray = [...Section1Array];
    newArray.splice(index, 1);
    formik.values.section_2.splice(index, 1);
    setSection1Array(newArray);
  };

  const handleAddInputForSection2Array = () => {
    setSection2Array([...Section2Array, { name: '', }]);
    formik.values.section_3.push({
      title: '',
      description: '',
      embracing_core_values: '',
    });
  };

  const handleDeleteInputForSection2Array = (index) => {
    setSection2Array([...Section2Array, { name: '', }]);
    const newArray = [...Section2Array];
    newArray.splice(index, 1);
    formik.values.section_3.splice(index, 1);
    setSection2Array(newArray);
  };

  const handleAddInputForSection3Array = () => {
    setSection3Array([...Section3Array, { name: '', }]);
    formik.values.section_4.push({
      title: '',
      description: '',
      embracing_core_values: '',
    });
  };

  const handleDeleteInputForSection3Array = (index) => {
    setSection3Array([...Section3Array, { name: '', }]);
    const newArray = [...Section3Array];
    newArray.splice(index, 1);
    formik.values.section_4.splice(index, 1);
    setSection3Array(newArray);
  };

  const handleAddInputForSection4Array = () => {
    setSection4Array([...Section4Array, { name: '', }]);
    formik.values.section_5.push({
      title: '',
      description: '',
    });
  };

  const handleDeleteInputForSection4Array = (index) => {
    setSection4Array([...Section4Array, { name: '', }]);
    const newArray = [...Section4Array];
    newArray.splice(index, 1);
    formik.values.section_5.splice(index, 1);
    setSection4Array(newArray);
  };

  const handleBackClick = () => {
    navigate('/form-dashboard', { state: { selectedId: editId } });
  };

  //! ------------------------------------

  const supervisorDropdown = () => {
    return (<Dropdown
      optionValue='user_id'
      id="supervisor_id"
      name="supervisor_id"
      placeholder="Select a Supervisor"
      options={allSupervisors}
      optionLabel={(e) => { return e.first_name + ' ' + e.last_name }}
      value={formik.values.supervisor_id}
      className='p-2'
      style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '14px', color: 'white', border: 'none' }}
      onChange={(e) => {
        var sp = allSupervisors.find((s) => s.user_id === e.value)
        if (sp) {
          formik.setFieldValue('supervisor_name', sp.first_name + ' ' + sp.last_name)
          console.log('hhhhhhhhhh-', formik.values.supervisor_name);
        }
        formik.setFieldValue('supervisor_id', e.value);
      }}
    />
    );
  }

  const ccDropdowng = () => {
    return (
      <MultiSelect value={selectedCCList} onChange={(e) => {

        setSelectedCCList(e.value)

        console.log(selectedCCList)


        // formik.setFieldValue('cc_users', e.value[0].user_id)
      }} options={allSupervisors} optionLabel={(e) => { return e.first_name + ' ' + e.last_name + ' - ' + e.role_name }} display="chip" filter
        placeholder="Select CC" className="m-2 p-2 w-full mutiii" />
    );
  };

  return (

    <>
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="form-container" style={{ padding: '10px' }}>
          <main className="content-area">
            <div ref={formRef} className="print-container">
              <form onSubmit={openSavePopup}>
                <Toast ref={toast} />
                <div className='form-box' >

                  <div className="bg-yellow-200 flex justify-between py-2 px-4 sticky-header no-print" style={{ position: 'ticky', top: 0, alignItems: 'center' }} >
                    <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                      <IoArrowBackSharp className='text-sm' />
                      <span>Back</span>
                    </button>

                    <div className="mx-auto">
                      <h2 className="main-title-font"> Quarterly Huddle Conversation</h2>
                    </div>

                    <div className="flex gap-2">
                      <Button className='p-2 px-3 m-2 customSave-button'
                        title='Save' loading={saveLoading} type='button' onClick={directSave}>
                        <FaSave className='mr-2' />
                        <span>Save</span>
                      </Button>

                      <Button className='p-2 px-3 m-2 customSave-button'
                        title='Print' type='button' onClick={handlePrint}>
                        <FaPrint className='mr-2' />
                        <span>Print</span>
                      </Button>

                      <Button className='p-2 px-3 copySave-button'
                        title='Save And Send Message'
                        loading={saveLoading}>
                        <FaEnvelope className='mr-2' />
                        <span>Send Message</span>
                      </Button>
                    </div>

                  </div>

                  <div className="items-center justify-center h-screen"  id="formRef" >

                    {/* --------First------------- */}
                    <div>
                      <table style={{ borderCollapse: "collapse", width: "auto", display: "flex", justifyContent: "center" }} className='m-4' >
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, minWidth: "300px", }} >
                              Team Member Name:
                            </td>
                            <td style={{ ...cellStyle, minWidth: "350px" }} >
                              {renderInputArea('team_member_name', 'Team Member Name', 'text', '', true)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStyle, minWidth: "300px", }} >
                              Supervisor Name:
                            </td>
                            <td style={{ ...cellStyle, minWidth: "350px" }} >
                              {formik.values.is_supervisor == true ? supervisorDropdown() : renderInputArea('supervisor_name', 'Supervisor Name', 'text', '', true)}
                              {/* {formik.values.is_supervisor==true?renderInputArea('supervisor_name', 'Supervisor Name'):renderInputArea('supervisor_name', 'Supervisor Name')} */}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStyle, minWidth: "300px", }} >
                              Date:
                            </td>
                            <td style={{ ...cellStyle, minWidth: "350px" }} >
                              {renderInputArea('date', '', 'date')}
                            </td>
                          </tr>

                          <tr>
                            <td style={{ ...cellStyle, minWidth: "300px", }} >
                              Quarter
                            </td>
                            <td style={{ ...cellStyle, minWidth: "300px", padding: 0 }} >
                              {renderSelect1('quater')}
                            </td>
                          </tr>

                          <tr>
                            <td style={{ ...cellStyle, minWidth: "300px", }} >
                              Year
                            </td>
                            <td style={{ ...cellStyle, minWidth: "300px", padding: 0 }} >
                              {renderYearSelect('year')}
                            </td>
                          </tr>

                        </tbody>
                      </table>
                      <div className='px-1 py-3'>
                        <p className="mt-2 paragraph"><strong>NOTE: PLEASE COMPLETE THE FOLLOWING AREAS:</strong> Your Goals, the LIDA Homes Core Values, your Roles and Responsibilities, your Measurables, the People Analyzer/GWC, and the Delegate/Elevate exercise (annually). Please then rate the culture and your job satisfaction, and bring this document to your Quarterly Conversation.</p>

                      </div>

                    </div>


                    {/* //* 1------- Rocks------------ */}
                    <div className="mb-6"> </div>
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">Rocks</h2>
                    </div>
                    <div className="px-0 py-3">
                      <h3 className="subtitle-font  mb-3">
                        Your 1-5 Goals are. How are they going? Are you on track or off track?
                      </h3>
                      <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                        <thead>
                        </thead>
                        <tbody>
                          {Section1Array.map((item, key) => (
                            <tr key={key}>
                              <td style={{ ...cellStyleW, width: '100px' }}>
                                {renderInputArea(`section_2.${key}.title`, '', 'text', formik.values.section_2[key].title)}
                              </td>
                              <td style={{ ...cellStyleW, minWidth: "600px" }}>
                                {renderTextAreaFull(`section_2.${key}.description`, '', formik.values.section_2[key].description, 2)}
                              </td>
                              <td style={{ ...cellStyleW, width: "100px" }}>
                                {renderSelectDone(`section_2.${key}.rocks_done`, formik.values.section_2[key].rocks_done)}
                              </td>

                              <td style={{ ...cellStyleW, width: '100px' }}>

                                {key != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection1Array(key)} />) : null}

                                {Section1Array.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection1Array()} />) : null}

                              </td>

                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                    {/* //! 1------- Rocks------------ */}


                    {/* //*------- Purpose ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4 '>
                      <h2 className="form-title-font">
                        Purpose
                      </h2>
                    </div>
                    <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                      <h4 className="subtitle-font  mb-3">
                        Why do we do what we do?
                      </h4>
                      <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                        <thead>

                        </thead>
                        <tbody>
                          {/* {Section3Array.map((item, index) => (
                        <tr key={index}>

                          <td style={{ ...cellStyleW, width: '100px' }}>
                            {renderInputArea(`section_4.${index}.title`, '', 'text', formik.values.section_4[index].title)}
                          </td>
                          <td style={{ ...cellStyleW, minWidth: "600px" }}>
                            {renderTextAreaFull(`section_4.${index}.description`, '', formik.values.section_4[index].description)}
                          </td>

                          <td style={{ ...cellStyleW, width: '100px' }}>

                            {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection3Array(index)} />) : null}

                            {Section3Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection3Array()} />) : null}

                          </td>

                        </tr>
                      ))} */}
                          <tr>
                            <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px' }}>
                              Creating a "WOW" Experience for our Team and Clients.
                            </td>
                          </tr>

                        </tbody>
                      </table>
                      <div className='flex  mt-4' style={{ alignItems: 'center', gap: '20px' }}>
                        <p>Are you embracing the companies purpose?</p>
                        <div style={{ width: '100px' }}>
                          {renderSelect('section_4.0.embracing_core_values', formik.values.section_4[0].embracing_core_values)}
                        </div>
                      </div>
                    </div>
                    {/* //!------- Purpose ------------ */}

                    {/* //*-------Core Values------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">Core Values</h2>
                    </div>
                    <div className="px-0 py-3" >
                      <h4 className="subtitle-font  mb-3">
                        The 3 LIDA Construction Core Values, we hire, fire and promote on them.
                      </h4>
                      <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                        <thead>

                        </thead>
                        <tbody>
                          {/* {Section2Array.map((item, index) => (
                        <tr key={index}>

                          <td style={{ ...cellStyleW, width: '100px' }}>{renderInputArea(`section_3.${index}.title`, '', 'text', formik.values.section_3[index].title)} </td>
                          <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`section_3.${index}.description`, '', formik.values.section_3[index].description, 2)} </td>

                          <td style={{ ...cellStyleW, width: '100px' }}>

                            {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection2Array(index)} />) : null}

                            {Section2Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection2Array()} />) : null}

                          </td>

                        </tr>
                      ))} */}
                          <tr >
                            <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                              We Are Committed to Excellence in all that we do.
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                              We Do What We Say We Are Going To Do
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "600px", padding: '10px', display: 'block' }}>
                              We Are the ultimate Team Players
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <div className='flex  mt-4' style={{ alignItems: 'center', gap: '20px' }}>
                        <p >Are you embracing the companies Core Values? </p>
                        <div style={{ width: '100px' }}>
                          {renderSelect('section_3.0.embracing_core_values', formik.values.section_3[0].embracing_core_values)}
                        </div>
                      </div>
                    </div>
                    {/* //!-------Core Values------------ */}

                    {/* //*------- The People Analyzer ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        The People Analyzer
                      </h2>
                    </div>
                    <div className="px-0 py-3">
                      <div className="table-responsive" style={{ overflowX: "auto", maxWidth: "100%" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%", minWidth: "1200px" }}>
                          <thead>
                            <tr>
                              <th style={{ ...headerStyle, width: "16%" }} >
                                
                              </th>
                              <th style={{ ...headerStyle, width: "42%" }} colSpan={3} >
                                Company Core Values
                              </th>
                              <th style={{ ...headerStyle, width: "42%" }} colSpan={3} >
                                Current job responsibilities
                              </th>
                            </tr>
                            <tr>
                              <th style={{ ...headerStyle }} >
                                Name (Rate yourself first)
                              </th>
                              <th style={{ ...headerStyle }} >
                                Teamwork
                              </th>
                              <th style={{ ...headerStyle }} >
                                Committed To Excellence
                              </th>
                              <th style={{ ...headerStyle }} >
                                We Always do What we Say We are Going to do
                              </th>
                              <th style={{ ...headerStyle }} >
                                Gets It Yes/No
                              </th>
                              <th style={{ ...headerStyle }} >
                                Wants It Yes/No
                              </th>
                              <th style={{ ...headerStyle }} >
                                Has the Capacity to do it Yes/No
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td style={{ ...cellStyle }} >
                                {renderInputArea(`section_8.0.name`, '', 'text', formik.values.section_8[0].name)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.0.teamwork`, formik.values.section_8[0].teamwork)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.0.committed_to_excellence`, formik.values.section_8[0].committed_to_excellence)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.0.we_always_do`, formik.values.section_8[0].we_always_do)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.0.gets_it`, formik.values.section_8[0].gets_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.0.wants_it`, formik.values.section_8[0].wants_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.0.has_the_capacity`, formik.values.section_8[0].has_the_capacity)}
                              </td>
                            </tr>

                            <tr>
                              <td style={{ ...cellStyle }} >
                                {renderInputArea(`section_8.1.name`, '', 'text', formik.values.section_8[1].name)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.1.teamwork`, formik.values.section_8[1].teamwork)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.1.committed_to_excellence`, formik.values.section_8[1].committed_to_excellence)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.1.we_always_do`, formik.values.section_8[1].we_always_do)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.1.gets_it`, formik.values.section_8[1].gets_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.1.wants_it`, formik.values.section_8[1].wants_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.1.has_the_capacity`, formik.values.section_8[1].has_the_capacity)}
                              </td>
                            </tr>

                            <tr>
                              <td style={{ ...cellStyle }} >
                                {renderInputArea(`section_8.2.name`, '', 'text', formik.values.section_8[2].name)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.2.teamwork`, formik.values.section_8[2].teamwork)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.2.committed_to_excellence`, formik.values.section_8[2].committed_to_excellence)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect2(`section_8.2.we_always_do`, formik.values.section_8[2].we_always_do)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.2.gets_it`, formik.values.section_8[2].gets_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.2.wants_it`, formik.values.section_8[2].wants_it)}
                              </td>
                              <td style={{ ...cellStyle }} >
                                {renderSelect(`section_8.2.has_the_capacity`, formik.values.section_8[2].has_the_capacity)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className='px-4 py-2' style={{ marginTop: '25px' }}>
                        <strong> Ratings: </strong> + l +/- l -
                        <p className='py-2'>+ = 80% - 100%</p>
                        <p className='py-2'> +/- = 60% - 80%</p>
                        <p className='py-2'> - = less than 60% The bar is 80% </p>
                      </div>
                    </div>
                    {/* //!------- The People Analyzer ------------ */}

                    {/* //*------- Roles & Responsibility --------- */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        Roles & Responsibility
                      </h2>
                    </div>
                    <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                      <h4 className="subtitle-font  mb-3">
                        Your 5-7 Roles and Responsibilities. Do you understand your roles and responsibilities? Do you need to add or delete any?
                      </h4>

                      <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                        <thead>
                        </thead>
                        <tbody>
                          {Section4Array.map((item, index) => (
                            <tr key={index}>

                              <td style={{ ...cellStyleW, width: '100px' }}>
                                {renderInputArea(`section_5.${index}.title`, '', 'text', formik.values.section_5[index].title)}
                              </td>
                              <td style={{ ...cellStyleW, minWidth: "600px" }}>
                                {renderTextAreaFull(`section_5.${index}.description`, '', formik.values.section_5[index].description)}
                              </td>

                              <td style={{ ...cellStyleW, width: '100px' }}>

                                {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection4Array(index)} />) : null}

                                {Section4Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection4Array()} />) : null}

                              </td>

                            </tr>
                          ))}

                        </tbody>
                      </table>

                    </div>
                    {/* //!------- Roles And Responsibility --------- */}

                    {/* //*------- Measurables-------- */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        Measurables
                      </h2>
                    </div>
                    <div className="px-0 py-3" >
                      <h4 className="subtitle-font  mb-3">
                        List your measurables here. Do you understand each of them? Should we add or delete any of your measurables? Did you reach your goal for the total of all your measurables (90%) ?Your 5-7 Roles and Responsibilities. Do you understand your roles and responsibilities? Do you need to add or delete any ?
                      </h4>
                      
                      <div className="mb-6"> </div>

                      <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, width: "auto", }} >
                              My total measurable score from the last quarter in Ninety is:
                            </td>
                            <td style={{ ...cellStyle, width: "150px", textAlign: 'end' }} >
                              {renderInputArea(`section_6.0.my_total`, '', 'text', formik.values.section_6[0].my_total)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStyle, }} >
                              Are your measurables on track?
                            </td>
                            <td style={{ ...cellStyle, }} >
                              {renderSelect(`section_6.0.measurable_track`, formik.values.section_6[0].measurable_track)}
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <div className="" style={{ ...cellStyle }} >
                        {renderTextAreaFull(`section_6.0.measurables_comments`, '', formik.values.section_6[0].measurables_comments, 8)}
                      </div>
                    </div>
                    {/* //!------- Measurables-------- */}

                    {/* //*------- The 4 Management Practices ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        The 4 Management Practices
                      </h2>
                    </div>
                    <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                      <h4 className="subtitle-font  mb-3">
                        Provide feedback to your supervisor on their performance:
                      </h4>

                      <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tbody>

                          <tr>
                            <td style={{ ...cellStylec, width: "100px" }}>
                              1
                            </td>
                            <td style={{ ...cellStyle, width: "auto", }}>
                              Is he/she keeping expectations clear?
                            </td>
                            <td style={{ ...cellStyle, width: "150px", textAlign: "right" }}>
                              {renderSelect(`section_7.0.keeping_expectations`, formik.values.section_7[0].keeping_expectations)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStylec, }} >
                              2.
                            </td>
                            <td style={{ ...cellStyle, }} >
                              Is he/she communicating well?
                            </td>
                            <td style={{ ...cellStyle, }} >
                              {renderSelect(`section_7.0.communicating_well`, formik.values.section_7[0].communicating_well)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStylec, }} >
                              3
                            </td>
                            <td style={{ ...cellStyle, }} >
                              Is he/she maintaining/participating in the L10 for the right meeting pulse?
                            </td>
                            <td style={{ ...cellStyle, }} >
                              {renderSelect(`section_7.0.meeting_pulse`, formik.values.section_7[0].meeting_pulse)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ ...cellStylec, }} >
                              4
                            </td>
                            <td style={{ ...cellStyle, }} >
                              Is he/she having quarterly conversations with you?
                            </td>
                            <td style={{ ...cellStyle, }} >
                              {renderSelect(`section_7.0.quarterly_conversations`, formik.values.section_7[0].quarterly_conversations)}
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                    {/* //!------- The 4 Management Practices ------------ */}

                    {/* //*------- Quarterly Huddle conversation------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        Quarterly Huddle conversation
                      </h2>
                    </div>
                    <div className="px-0 " style={{ overflowX: "auto" }}>
                      <div className='bg-gray-800 text-white py-2 px-4 '>
                        <h4 className="text-md font-bold form-title-font-white">
                          1. What&apos;s workings ?
                        </h4>
                      </div>
                      <table >
                        <tbody>
                          <tr>

                            <td style={{ ...cellStyle, }} className='w-full' >
                              {renderTextAreaFull(`section_9.0.whats_working_title`, '', formik.values.section_9[0].whats_working_title)}
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div className="px-0 " style={{ overflowX: "auto" }}>
                      <div className='bg-gray-800 text-white py-2 px-4 '>
                        <h4 className="text-md font-bold form-title-font-white">2.What’s not working?</h4>
                      </div>
                      <table >
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, }} className='w-full' >
                              {renderTextAreaFull(`section_9.0.whats_not_working_title`, '', formik.values.section_9[0].whats_not_working_title)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="px-0 " style={{ overflowX: "auto" }}>
                      <div className='bg-gray-800 text-white py-2 px-4 '>
                        <h4 className="text-md font-bold form-title-font-white">3.Next Steps. What do you think we can do to improve and what can your supervisor do to help?</h4>
                      </div>
                      <table >
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, }} className='w-full' >
                              {renderTextAreaFull(`section_9.0.next_steps_title`, '', formik.values.section_9[0].next_steps_title)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="px-0 " style={{ overflowX: "auto" }}>
                      <div className='bg-gray-800 text-white py-2 px-4 '>
                        <h4 className="text-md font-bold form-title-font-white">
                          4.Provide Feedback. How is your supervisor doing? What can he/she do for you personally and professionally?
                        </h4>
                      </div>
                      <table >
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, }} className='w-full' >
                              {renderTextAreaFull(`section_9.0.provide_feedback_title`, '', formik.values.section_9[0].provide_feedback_title)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="px-0 " style={{ overflowX: "auto" }}>
                      <div className='bg-gray-800 text-white py-2 px-4'>
                        <h4 className="text-md font-bold form-title-font-white">
                          5. What are you doing to improve personally and professionally?
                        </h4>
                      </div>
                      <table >
                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, }} className='w-full' >
                              {renderTextAreaFull('section_9.0.improve_personally_professionally_title', '', formik.values.section_9[0].improve_personally_professionally_title)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* //!------- Quarterly Huddle conversation------------ */}

                    {/* //*------- Culture & Job satisfaction ------------ */}
                    <div>
                      <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                        <h2 className="form-title-font">
                          Culture & Job satisfaction
                        </h2>
                      </div>
                      <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", width: "auto" }}>

                          <tbody>
                            <tr>
                              <td style={{ ...cellStylec, minWidth: "100px", }} >
                                1
                              </td>
                              <td style={{ ...cellStyle, minWidth: "70vw" }} >
                                On a scale of 1-10, with 1 being the culture is horrible to 10 being I love the culture, how would you rate the culture at LIDA Homes?
                              </td>
                              <td style={{ ...cellStyle, minWidth: "50px" }} >
                                {renderInputArea('section_10.0.short_desc', '', '', formik.values.section_10[0].short_desc)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ ...cellStylec, }} >
                                2.
                              </td>
                              <td style={{ ...cellStyle, }} >
                                On a scale of 1-10, with 1 being I am not satisfied with my job and 10 being I love my job, how would you rate your job satisfaction?
                              </td>
                              <td style={{ ...cellStyle, }} >
                                {renderInputArea('section_10.1.short_desc', '', '', formik.values.section_10[1].short_desc)}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ ...cellStyleh, }} >
                                3
                              </td>
                              <td style={{ ...cellStyle, }} colSpan={2} >
                                What is one thing we can do to improve the culture?
                              </td>

                            </tr>
                            <tr>
                              <td style={{ ...cellStyle }} colSpan={3}>
                                {renderTextAreaFull('section_10.2.short_desc', '', formik.values.section_10[2].short_desc)}
                              </td>

                            </tr>
                            <tr>
                              <td style={{ ...cellStyleh, }} >
                                4
                              </td>
                              <td style={{ ...cellStyle, }} colSpan={2} >
                                What is one thing we can do to improve your job satisfaction?
                              </td>

                            </tr>
                            <tr>
                              <td style={{ ...cellStyle, }} colSpan={3}>
                                {renderTextAreaFull('section_10.3.short_desc', '', formik.values.section_10[3].short_desc)}
                              </td>

                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* //!------- Culture & Job satisfaction ------------ */}

                    {/* //*------- Delegate & Elevate Exercise ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <h2 className="form-title-font">
                        Delegate & Elevate Exercise
                      </h2>
                    </div>
                    <div className="px-0 py-3" style={{ overflowX: "auto" }}>
                      <div className="mb-4">
                        <h4>Find your unique Abilities.</h4>
                        <p>(Complete the Delegate and Elevate exercise at the start of every year) </p>
                      </div>

                      <div >
                        <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                          <th style={{ ...headerStyle }} >
                            Love/Great at
                          </th>
                          <th style={{ ...headerStyle }} >
                            Like/Good at
                          </th>
                        </tr>

                        <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                          <td style={{ ...cellStyle, }} >
                            {renderTextAreaFull('section_11.0.love_great_at_desc', '', formik.values.section_11[0].love_great_at_desc)}
                          </td>
                          <td style={{ ...cellStyle, }} >
                            {renderTextAreaFull('section_11.0.like_good_at_desc', '', formik.values.section_11[0].like_good_at_desc)}
                          </td>
                        </tr>
                      </div>

                      <div>
                        <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                          <th style={{ ...headerStyle }} >
                            Don't Like/Good at
                          </th>
                          <th style={{ ...headerStyle }} >
                            Don't Like/Not Good At
                          </th>
                        </tr>
                        <tr style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                          <td style={{ ...cellStyle, }} >
                            {renderTextAreaFull('section_11.0.dont_like_good_at_desc', '', formik.values.section_11[0].dont_like_good_at_desc)}
                          </td>
                          <td style={{ ...cellStyle, }} >
                            {renderTextAreaFull('section_11.0.dont_like_not_good_at_desc', '', formik.values.section_11[0].dont_like_not_good_at_desc)}
                          </td>
                        </tr>
                      </div>


                      <table style={{ borderCollapse: "collapse", width: "100%", }}>
                        <thead>
                          <tr>
                            <th style={{ ...headerStyle, minWidth: "100px", }} colSpan={2} >
                              Identify at least one thing you do in Don’t Like/Good At or Don’t Like/Not Good At and
                              delegate it:</th>

                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td style={{ ...cellStyle, }} >
                              {renderTextAreaFull('section_11.0.notes', '', formik.values.section_11[0].notes)}
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                    {/* //!------- Delegate & Elevate Exercise ------------ */}

                    {/* //*-------Supervisor Notes------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <div className="builder-form-notes-center">
                        <Checkbox
                          name="supervisor_status"
                          value={formik.values.supervisor_status}
                          checked={formik.values.supervisor_status == 'Y' ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue('supervisor_status', e.target.checked ? 'Y' : 'N');
                          }}
                        />
                        <label htmlFor="supervisor_notes" className="ml-2 form-title-font">Supervisor Notes</label>
                      </div>
                    </div>
                    <div className="py-3" >
                      {renderTextAreaFull('supervisor_notes', '', formik.values.supervisor_notes, 8)}
                    </div>
                    {/* //!-------Supervisor Notes ------------ */}

                    {/* //*------- VP Construction Operations Notes  ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <div className="builder-form-notes-center">
                        <Checkbox
                          name="vp_construction"
                          value={formik.values.vp_construction}
                          checked={formik.values.vp_construction == 'Y' ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue('vp_construction', e.target.checked ? 'Y' : 'N');
                          }}
                        />
                        <label htmlFor="vp_construction_notes" className="ml-2 form-title-font">VP Construction Operations Notes</label>
                      </div>
                    </div>
                    <div className="py-3" >
                      {renderTextAreaFull('vp_construction_notes', '', formik.values.vp_construction_notes, 8)}
                    </div>
                    {/* //!------- VP Construction Operations Notes  ------------ */}

                    {/* //*------- President Notes Start ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <div className="builder-form-notes-center">
                        <Checkbox
                          name="president"
                          value={formik.values.president}
                          checked={formik.values.president == 'Y' ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue('president', e.target.checked ? 'Y' : 'N');
                          }}
                        />
                        <label htmlFor="president" className="ml-2 form-title-font">President Notes</label>
                      </div>
                    </div>
                    <div className="py-3" >
                      {renderTextAreaFull('president_notes', '', formik.values.president_notes, 8)}
                    </div>
                    {/* //!------- President Notes Start End ------------ */}

                    {/* //*------- Human Resources Notes Start ------------ */}
                    <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                      <div className="builder-form-notes-center">
                        <Checkbox
                          name="human_resources"
                          value={formik.values.human_resources}
                          checked={formik.values.human_resources == 'Y' ? true : false}
                          onChange={(e) => {
                            formik.setFieldValue('human_resources', e.target.checked ? 'Y' : 'N');
                            console.log(e.target.checked)
                          }}
                        />
                        <label htmlFor="he" className="ml-2 form-title-font">Human Resources Notes</label>
                      </div>
                    </div>
                    <div className="py-3" >
                      {renderTextAreaFull('human_resources_notes', '', formik.values.human_resources_notes, 8)}
                    </div>
                    {/* //!------- Human Resources Notes End ------------ */}

                  </div>
                </div>

              </form>
            </div>

          </main>
          {/* //!-------------------Form End------------------- */}



          <Dialog header="Enter a Custom Message" visible={isSavePopupOpen} style={{ width: '40vw' }} dismissableMask={true} onHide={() => setIsSavePopupOpen(false)}>

            <div className="p-2">
              <form onSubmit={handleSaveSubmit} className="">
                <div className="">
                  <div className='col-12 pt-2'>
                    <label htmlFor="to" >
                      {/* To : <strong> {formik.values.team_member_name} </strong> */}
                      To : <strong> {showName} </strong>
                      <Checkbox
                        name="team_member_name"
                        className='ml-4'
                        value={to}
                        checked={to == 'Y' ? true : false}
                        onChange={(e) => {
                          setTo(e.target.checked ? 'Y' : 'N');
                        }}
                      />
                    </label>
                  </div>
                  <div className='col-12 pt-2 multee'>

                    {ccDropdowng()}
                  </div>
                  <div style={{ marginLeft: '8px' }}>CC:</div>
                  {
                    selectedCCList.map((item, index) =>

                    (
                      <div style={{ fontWeight: 'bold', marginLeft: '38px', paddingBottom: '8px' }} >  {item.first_name + ' ' + item.last_name + ' (' + item.role_name + ')'} </div>)
                    )
                  }


                  <div className='col-12 pt-2 '>
                    <label htmlFor="customSubject" >Subject </label>
                    <InputTextarea
                      id="customSubject"
                      value={customSubject}
                      onChange={(e) => setCustomSubject(e.target.value)}
                      className="p-inputtext p-component p-2"
                      style={{ width: '95%', marginTop: '10px' }}
                    />
                  </div>

                  <div className="col-12 pt-2">
                    <label htmlFor="customMessage" className='pb-10'>Message</label>
                    <Editor
                      id="customMessage"
                      value={customMessage}
                      onTextChange={(e) => {
                        // console.log(e.htmlValue);
                        setCustomMessage(e.htmlValue)
                      }}
                      style={{ height: '220px' }} />
                  </div>
                  <div className=" flex flex-wrap justify-content-center ">
                    <Button label="Submit" type="submit" className="p-2 px-3 customSave-button" severity="success" />
                  </div>
                </div>
              </form>
            </div>
          </Dialog>

        </div>
      )}

    </>
  );
}

export default QuarterlyConversation;
